<template>
    <div class="base-card__content credit-content">
        <div class="credit-content__wrapper">
            <div class="credit-content__image-skeleton"/>
        </div>
        <div class="credit-content__name-skeleton"/>
        <div class="credit-content__descr-skeleton"/>
    </div>
</template>
